///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2024 - 2025
//                                    RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { bidScacType } from "../../helpers/types";
import messages from "../../helpers/messages";

function BidFormat({ bid: { bidScac }, setBidState, disableFTLBid, disableIMDLBid }) {
  return (
    <>
      <span>{messages.selectBidFormat.defaultMessage}</span>
      <div className="mode-selected pt-12 pb-24 flex">
        <button
          data-testid="ltl-imdl-button"
          className={`bg-white mr-24 flex flex-col items-center justify-center ${
            bidScac.value === bidScacType[0].value ? "selected" : ""
          }`}
          onClick={() => setBidState("bidScac", bidScacType[0])}
        >
          <span>
            {disableIMDLBid
              ? messages.ltl.defaultMessage
              : messages.ltlImdl.defaultMessage}
          </span>
        </button>
        {!disableFTLBid && (
          <button
            data-testid="ftl-button"
            className={`bg-white flex flex-col items-center justify-center ${
              bidScac.value === bidScacType[1].value ? "selected" : ""
            }`}
            onClick={() => setBidState("bidScac", bidScacType[1])}
          >
            <span>{messages.ftl.defaultMessage}</span>
          </button>
        )}
      </div>
    </>
  );
}

export default BidFormat;
